<template>
  <div class="newsfeed-settings-page">
    <div class="newsfeed-settings-page__title">{{ $t('news.setting_universal_login_kuban') }}</div>
    <div
      class="newsfeed-settings-page__subtitle"
    >{{ $t('news.connect_auth_via_gosuslugi') }}</div>
    <auth-settings></auth-settings>
  </div>
</template>
<script>
  import authSettings from '@/components/Settings/auth.vue';

  export default {
    name: 'authSettingsPage',
    components: {authSettings}
  }
</script>